module.exports = __webpack_public_path__ + "static/media/L diag.a7658270.jpg";